/**
 * Created by tomers on 6/18/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/agent-groups/agentGroupsGridRowView.tmpl");

    var Checkbox = require("ui/checkbox/Checkbox");
    var Loader = require("ui/loader/Loader");
    var PlusCompositeView = require("ui/plus-composite-view/PlusCompositeView");

    var EMPTY_DATA = " - ";

    var AgentGroupsGridRowView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        AgentGroupsGridRowView = Marionette.ItemView.extend({
            tagName: "tr",
            className: "agent-group-move-row",
            template: template,
            loaders: [],
            ui: {
                selector: ".selector",
                name: ".name .content",
                nameContainer: ".name",
                parentGroup: ".parent-group",
                managers: ".managers",
                managersContent: ".managers .content",
                members: ".members",
                subGroups: ".sub-groups"
            },
            uiComponents: {
                selectorCheckbox: {
                    type: Checkbox,
                    options: {
                        el: "view.ui.selector",
                        checked: false,
                        label: "",
                        permutation: Checkbox.PERMUTATION.B // no label
                    },
                    events: {
                        "change": "_onSelectorChange"
                    }
                }
            },
            events: {
                "click @ui.selector": "_onSelectorWrapperClick",
                "click @ui.nameContainer": "_onSelectorWrapperClick",
                "click @ui.parentGroup": "_onSelectorWrapperClick",
                "click @ui.managers": "_onSelectorWrapperClick",
                "click @ui.members": "_onSelectorWrapperClick",
                "click @ui.subGroups": "_onSelectorWrapperClick"
            },

            initialize: function() {
                this.loaders = [];
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.AGENT_GROUP_MOVE);
                this._bindEvents();
            },

            onRender: function() {
                this._updateName();
                this._updateParentGroupName();
                this._updateManagers();
                this._updateMembers();
                this._updateSubGroups();
                this._setTooltipOnName();
            },

            _bindEvents: function () {
                this.listenTo(this.model, "model:selection:change", this._onModelSelectionChange);
            },

            _updateName: function() {
                var name = this.model.getName();
                this.ui.name.text(name);
            },

            _updateParentGroupName: function() {
                var dataManager = LEUserManagement.getDataManager();
                var parentGroupName = dataManager.getNameById(dataManager.getEntities().AGENT_GROUP, this.model.getParentGroupId());
                if (!parentGroupName) {
                    parentGroupName = EMPTY_DATA;
                }
                this.ui.parentGroup.text(parentGroupName);
            },

            _updateManagers: function() {
                if (this.uiComponents.managers) {
                    this.uiComponents.managers.close();
                }

                var managers = this.model.getManagers();

                if (managers.length > 0) {
                    this.uiComponents.host$.createAndRender("managers", {
                        type: PlusCompositeView,
                        options: {
                            container: "view.ui.managersContent",
                            collection: "view._getManagersCollection",
                            textModelAttr: "tooltip",
                            visibleItemsCount: 2,
                            itemView: PlusCompositeView.DefaultPlusComponentItemView
                        }
                    });
                }
                else {
                    this.ui.managers.text(EMPTY_DATA);
                }
            },

            _updateMembers: function() {
                var members = this.model.getMembers();
                if (members === this.model.NO_DATA) {
                    this.showLoader("members", true);
                }
                else {
                    this.showLoader("members", false);
                    if (members.length > 0) {
                        this.ui.members.text(members.length);
                    }
                    else {
                        this.ui.members.text(EMPTY_DATA);
                    }
                }
            },

            _updateSubGroups: function() {
                var subGroups = this.model.getSubGroups();
                this.ui.subGroups.text(subGroups.length);
            },

            _onSelectorWrapperClick: function(e) {
                if(e  && e.currentTarget && e.currentTarget.className !== "selector") {
                    this.uiComponents.selectorCheckbox.checkboxClick();
                }
            },

            _disableRow: function() {
                this.uiComponents.selectorCheckbox.setEnabled(false);
            },

            _setTooltipOnName: function() {
                var tooltip;
                if(_.isEmpty(this.model.get("description"))) {
                    tooltip = LE.translator.translate("LEUserManagement.agentGroupList.no.description.display");
                    this.ui.name.attr("title", tooltip);
                } else {
                    tooltip = this.model.get("description");
                    this.ui.name.attr("title", tooltip);
                }
            },

            _onSelectorChange: function(componentId, eventName, isChecked) {
                this.channel.trigger("row:selector:click", {itemModel:this.model, isChecked:isChecked});
            },

            _onModelSelectionChange: function(isChecked) {
                this.$el.toggleClass("selected", isChecked);
                this.uiComponents.selectorCheckbox.setCheckedState(isChecked);
            },

            showLoader:function (clmName, show) {
                this.ui[clmName].find(".loading").toggleClass("hide", !show);

                if (show) {
                    this.ui[clmName].find(".content").html("");
                    this.loaders[clmName] = new Loader({
                        permutation:Loader.PERMUTATION.H,
                        el:this.ui[clmName].find(".loading")
                    });
                    this.loaders[clmName].render();
                }
                else {
                    if (this.loaders[clmName]) {
                        this.loaders[clmName].close();
                        this.loaders[clmName] = null;
                    }
                }
            },

            _getManagersCollection: function() {
                var usersCollection = LEUserManagement.getDataManager().getUsersCollection();
                var managersIds = this.model.getManagers();
                var managersArr = [];
                _.each(managersIds, _.bind(function(managerId){
                    var userModel = usersCollection.get(managerId);
                    if (userModel) {
                        managersArr.push({
                            name: userModel.getDisplayName(),
                            tooltip: userModel.getDisplayName()
                        });
                    }
                }, this));

                managersArr.sort(function(a, b){
                    return a.name.toLowerCase() > b.name.toLowerCase() ? 1:-1;
                });

                return new PlusCompositeView.DefaultPlusComponentCollection(managersArr);
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return AgentGroupsGridRowView;
});
